import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { cn } from '@/lib/utils';

const SIZE_CLASSES = {
  sm: 'max-w-md',
  md: '',
  lg: 'max-w-2xl max-h-[80vh] overflow-y-auto',
};

// Standard portal dialog wrapper. Replaces the hand-built
// `<DialogTitle style={{ color: '#070B5F' }} className="font-serif">`
// pattern that used to be copy-pasted across ~14 portal files.
export default function DialogShell({
  open,
  onOpenChange,
  title,
  description,
  size = 'md',
  footer,
  children,
  className,
  ...rest
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={cn(SIZE_CLASSES[size], className)} {...rest}>
        <DialogHeader>
          <DialogTitle className="font-serif text-brand-navy">{title}</DialogTitle>
          {description ? <DialogDescription>{description}</DialogDescription> : null}
        </DialogHeader>
        {children}
        {footer ? <DialogFooter>{footer}</DialogFooter> : null}
      </DialogContent>
    </Dialog>
  );
}
